/** @var { SunModelState } */
const STATE = {
  fileLogs: {
    loading: false,
    loaded: false,
    data: {
      batchLogs: [],
      batchFileLogs: [],
    },
    batchFileUploadModalShow: false,
    batchFileUploadLoading: false,
    batchFileUploadData: [],
    batchFileUploadErrors: '',
    pagination: {
      perPage: 20,
      currentPage: 1,
    },
    batchUploadOptions: [],
    batchFileUploadOptions: [],
  },
  // Define the initial state for the jobQueue module
  jobQueue: {
    isLoading: false,
    data: null,
    page: {
      perPage: 10,
      currentPage: 1,
    },
    filteredData: null,
    searchValue: '',
    filterField: null,
  },
};

export default STATE;
